export default __webpack_public_path__ + "static/media/fund-card-banner-so-fund.3912c0dd.png";